var map = {
	"./Binary_Property/ASCII.js": "bricks/presentational-bricks:TTPM",
	"./Binary_Property/ASCII_Hex_Digit.js": "bricks/presentational-bricks:rKZ+",
	"./Binary_Property/Alphabetic.js": "bricks/presentational-bricks:PYyx",
	"./Binary_Property/Any.js": "bricks/presentational-bricks:hfac",
	"./Binary_Property/Assigned.js": "bricks/presentational-bricks:2TvA",
	"./Binary_Property/Bidi_Control.js": "bricks/presentational-bricks:BIHX",
	"./Binary_Property/Bidi_Mirrored.js": "bricks/presentational-bricks:Y6X3",
	"./Binary_Property/Case_Ignorable.js": "bricks/presentational-bricks:YL52",
	"./Binary_Property/Cased.js": "bricks/presentational-bricks:hHg9",
	"./Binary_Property/Changes_When_Casefolded.js": "bricks/presentational-bricks:xB3T",
	"./Binary_Property/Changes_When_Casemapped.js": "bricks/presentational-bricks:1N+G",
	"./Binary_Property/Changes_When_Lowercased.js": "bricks/presentational-bricks:v51b",
	"./Binary_Property/Changes_When_NFKC_Casefolded.js": "bricks/presentational-bricks:ayZG",
	"./Binary_Property/Changes_When_Titlecased.js": "bricks/presentational-bricks:IMPD",
	"./Binary_Property/Changes_When_Uppercased.js": "bricks/presentational-bricks:R1Ew",
	"./Binary_Property/Dash.js": "bricks/presentational-bricks:+3kn",
	"./Binary_Property/Default_Ignorable_Code_Point.js": "bricks/presentational-bricks:4/F7",
	"./Binary_Property/Deprecated.js": "bricks/presentational-bricks:wZUC",
	"./Binary_Property/Diacritic.js": "bricks/presentational-bricks:s0pm",
	"./Binary_Property/Emoji.js": "bricks/presentational-bricks:12hi",
	"./Binary_Property/Emoji_Component.js": "bricks/presentational-bricks:mzUC",
	"./Binary_Property/Emoji_Modifier.js": "bricks/presentational-bricks:0nmF",
	"./Binary_Property/Emoji_Modifier_Base.js": "bricks/presentational-bricks:+hQC",
	"./Binary_Property/Emoji_Presentation.js": "bricks/presentational-bricks:ep7J",
	"./Binary_Property/Extended_Pictographic.js": "bricks/presentational-bricks:gx40",
	"./Binary_Property/Extender.js": "bricks/presentational-bricks:jq6q",
	"./Binary_Property/Grapheme_Base.js": "bricks/presentational-bricks:ojcp",
	"./Binary_Property/Grapheme_Extend.js": "bricks/presentational-bricks:V3uO",
	"./Binary_Property/Hex_Digit.js": "bricks/presentational-bricks:4YcT",
	"./Binary_Property/IDS_Binary_Operator.js": "bricks/presentational-bricks:KgQe",
	"./Binary_Property/IDS_Trinary_Operator.js": "bricks/presentational-bricks:rZx1",
	"./Binary_Property/ID_Continue.js": "bricks/presentational-bricks:Z3Cz",
	"./Binary_Property/ID_Start.js": "bricks/presentational-bricks:/VW1",
	"./Binary_Property/Ideographic.js": "bricks/presentational-bricks:VdHZ",
	"./Binary_Property/Join_Control.js": "bricks/presentational-bricks:6XJR",
	"./Binary_Property/Logical_Order_Exception.js": "bricks/presentational-bricks:18Iv",
	"./Binary_Property/Lowercase.js": "bricks/presentational-bricks:RlPj",
	"./Binary_Property/Math.js": "bricks/presentational-bricks:ZtX9",
	"./Binary_Property/Noncharacter_Code_Point.js": "bricks/presentational-bricks:IZLa",
	"./Binary_Property/Pattern_Syntax.js": "bricks/presentational-bricks:YNcp",
	"./Binary_Property/Pattern_White_Space.js": "bricks/presentational-bricks:pLr0",
	"./Binary_Property/Quotation_Mark.js": "bricks/presentational-bricks:bVt1",
	"./Binary_Property/Radical.js": "bricks/presentational-bricks:V6iA",
	"./Binary_Property/Regional_Indicator.js": "bricks/presentational-bricks:gXbN",
	"./Binary_Property/Sentence_Terminal.js": "bricks/presentational-bricks:yNbx",
	"./Binary_Property/Soft_Dotted.js": "bricks/presentational-bricks:TP4o",
	"./Binary_Property/Terminal_Punctuation.js": "bricks/presentational-bricks:SPrB",
	"./Binary_Property/Unified_Ideograph.js": "bricks/presentational-bricks:lqdz",
	"./Binary_Property/Uppercase.js": "bricks/presentational-bricks:wJ4O",
	"./Binary_Property/Variation_Selector.js": "bricks/presentational-bricks:zYVL",
	"./Binary_Property/White_Space.js": "bricks/presentational-bricks:mCz8",
	"./Binary_Property/XID_Continue.js": "bricks/presentational-bricks:7jO/",
	"./Binary_Property/XID_Start.js": "bricks/presentational-bricks:CkxS",
	"./General_Category/Cased_Letter.js": "bricks/presentational-bricks:JTjc",
	"./General_Category/Close_Punctuation.js": "bricks/presentational-bricks:LZZ3",
	"./General_Category/Connector_Punctuation.js": "bricks/presentational-bricks:J7in",
	"./General_Category/Control.js": "bricks/presentational-bricks:ZKzb",
	"./General_Category/Currency_Symbol.js": "bricks/presentational-bricks:S/gH",
	"./General_Category/Dash_Punctuation.js": "bricks/presentational-bricks:OQyL",
	"./General_Category/Decimal_Number.js": "bricks/presentational-bricks:yyEx",
	"./General_Category/Enclosing_Mark.js": "bricks/presentational-bricks:aBVj",
	"./General_Category/Final_Punctuation.js": "bricks/presentational-bricks:K9hv",
	"./General_Category/Format.js": "bricks/presentational-bricks:Ohg8",
	"./General_Category/Initial_Punctuation.js": "bricks/presentational-bricks:DusV",
	"./General_Category/Letter.js": "bricks/presentational-bricks:PVUd",
	"./General_Category/Letter_Number.js": "bricks/presentational-bricks:/soj",
	"./General_Category/Line_Separator.js": "bricks/presentational-bricks:oOya",
	"./General_Category/Lowercase_Letter.js": "bricks/presentational-bricks:PeYj",
	"./General_Category/Mark.js": "bricks/presentational-bricks:yxwC",
	"./General_Category/Math_Symbol.js": "bricks/presentational-bricks:owBG",
	"./General_Category/Modifier_Letter.js": "bricks/presentational-bricks:6oKa",
	"./General_Category/Modifier_Symbol.js": "bricks/presentational-bricks:OMsT",
	"./General_Category/Nonspacing_Mark.js": "bricks/presentational-bricks:ezlQ",
	"./General_Category/Number.js": "bricks/presentational-bricks:0vCW",
	"./General_Category/Open_Punctuation.js": "bricks/presentational-bricks:JpfW",
	"./General_Category/Other.js": "bricks/presentational-bricks:BG0k",
	"./General_Category/Other_Letter.js": "bricks/presentational-bricks:v+A9",
	"./General_Category/Other_Number.js": "bricks/presentational-bricks:l/XR",
	"./General_Category/Other_Punctuation.js": "bricks/presentational-bricks:oeGF",
	"./General_Category/Other_Symbol.js": "bricks/presentational-bricks:5xM+",
	"./General_Category/Paragraph_Separator.js": "bricks/presentational-bricks:TveE",
	"./General_Category/Private_Use.js": "bricks/presentational-bricks:GS9R",
	"./General_Category/Punctuation.js": "bricks/presentational-bricks:CmM2",
	"./General_Category/Separator.js": "bricks/presentational-bricks:HpTs",
	"./General_Category/Space_Separator.js": "bricks/presentational-bricks:Buer",
	"./General_Category/Spacing_Mark.js": "bricks/presentational-bricks:9wuW",
	"./General_Category/Surrogate.js": "bricks/presentational-bricks:vudz",
	"./General_Category/Symbol.js": "bricks/presentational-bricks:/dLw",
	"./General_Category/Titlecase_Letter.js": "bricks/presentational-bricks:3O+O",
	"./General_Category/Unassigned.js": "bricks/presentational-bricks:QXET",
	"./General_Category/Uppercase_Letter.js": "bricks/presentational-bricks:rqE6",
	"./Script/Adlam.js": "bricks/presentational-bricks:Wry+",
	"./Script/Ahom.js": "bricks/presentational-bricks:GsYE",
	"./Script/Anatolian_Hieroglyphs.js": "bricks/presentational-bricks:dOYW",
	"./Script/Arabic.js": "bricks/presentational-bricks:FvNL",
	"./Script/Armenian.js": "bricks/presentational-bricks:/yAK",
	"./Script/Avestan.js": "bricks/presentational-bricks:GcGr",
	"./Script/Balinese.js": "bricks/presentational-bricks:LAM2",
	"./Script/Bamum.js": "bricks/presentational-bricks:7V9v",
	"./Script/Bassa_Vah.js": "bricks/presentational-bricks:kBqS",
	"./Script/Batak.js": "bricks/presentational-bricks:Jx5A",
	"./Script/Bengali.js": "bricks/presentational-bricks:fjIA",
	"./Script/Bhaiksuki.js": "bricks/presentational-bricks:2vIc",
	"./Script/Bopomofo.js": "bricks/presentational-bricks:HLRT",
	"./Script/Brahmi.js": "bricks/presentational-bricks:bntx",
	"./Script/Braille.js": "bricks/presentational-bricks:6O1M",
	"./Script/Buginese.js": "bricks/presentational-bricks:JFG7",
	"./Script/Buhid.js": "bricks/presentational-bricks:wnaP",
	"./Script/Canadian_Aboriginal.js": "bricks/presentational-bricks:OZnc",
	"./Script/Carian.js": "bricks/presentational-bricks:V8Tt",
	"./Script/Caucasian_Albanian.js": "bricks/presentational-bricks:WR1s",
	"./Script/Chakma.js": "bricks/presentational-bricks:vvaZ",
	"./Script/Cham.js": "bricks/presentational-bricks:BrKN",
	"./Script/Cherokee.js": "bricks/presentational-bricks:1CAE",
	"./Script/Chorasmian.js": "bricks/presentational-bricks:Sgk+",
	"./Script/Common.js": "bricks/presentational-bricks:A5PK",
	"./Script/Coptic.js": "bricks/presentational-bricks:HGcO",
	"./Script/Cuneiform.js": "bricks/presentational-bricks:8PCV",
	"./Script/Cypriot.js": "bricks/presentational-bricks:PVma",
	"./Script/Cyrillic.js": "bricks/presentational-bricks:6axZ",
	"./Script/Deseret.js": "bricks/presentational-bricks:OTnk",
	"./Script/Devanagari.js": "bricks/presentational-bricks:hSpq",
	"./Script/Dives_Akuru.js": "bricks/presentational-bricks:Hv6T",
	"./Script/Dogra.js": "bricks/presentational-bricks:D+nV",
	"./Script/Duployan.js": "bricks/presentational-bricks:juuj",
	"./Script/Egyptian_Hieroglyphs.js": "bricks/presentational-bricks:6wcF",
	"./Script/Elbasan.js": "bricks/presentational-bricks:xKmi",
	"./Script/Elymaic.js": "bricks/presentational-bricks:KDQ6",
	"./Script/Ethiopic.js": "bricks/presentational-bricks:ec/7",
	"./Script/Georgian.js": "bricks/presentational-bricks:h4fK",
	"./Script/Glagolitic.js": "bricks/presentational-bricks:hTB4",
	"./Script/Gothic.js": "bricks/presentational-bricks:lazI",
	"./Script/Grantha.js": "bricks/presentational-bricks:gwxh",
	"./Script/Greek.js": "bricks/presentational-bricks:9ulf",
	"./Script/Gujarati.js": "bricks/presentational-bricks:wQeB",
	"./Script/Gunjala_Gondi.js": "bricks/presentational-bricks:N7XW",
	"./Script/Gurmukhi.js": "bricks/presentational-bricks:TQJj",
	"./Script/Han.js": "bricks/presentational-bricks:9H9O",
	"./Script/Hangul.js": "bricks/presentational-bricks:jLBR",
	"./Script/Hanifi_Rohingya.js": "bricks/presentational-bricks:/I8K",
	"./Script/Hanunoo.js": "bricks/presentational-bricks:P0BJ",
	"./Script/Hatran.js": "bricks/presentational-bricks:duBa",
	"./Script/Hebrew.js": "bricks/presentational-bricks:uT2Q",
	"./Script/Hiragana.js": "bricks/presentational-bricks:edsp",
	"./Script/Imperial_Aramaic.js": "bricks/presentational-bricks:61NE",
	"./Script/Inherited.js": "bricks/presentational-bricks:Umia",
	"./Script/Inscriptional_Pahlavi.js": "bricks/presentational-bricks:nwfO",
	"./Script/Inscriptional_Parthian.js": "bricks/presentational-bricks:vAm1",
	"./Script/Javanese.js": "bricks/presentational-bricks:477v",
	"./Script/Kaithi.js": "bricks/presentational-bricks:4172",
	"./Script/Kannada.js": "bricks/presentational-bricks:hUzA",
	"./Script/Katakana.js": "bricks/presentational-bricks:V+/M",
	"./Script/Kayah_Li.js": "bricks/presentational-bricks:a0Op",
	"./Script/Kharoshthi.js": "bricks/presentational-bricks:IxPn",
	"./Script/Khitan_Small_Script.js": "bricks/presentational-bricks:dP5d",
	"./Script/Khmer.js": "bricks/presentational-bricks:QX2T",
	"./Script/Khojki.js": "bricks/presentational-bricks:Eo24",
	"./Script/Khudawadi.js": "bricks/presentational-bricks:+QyN",
	"./Script/Lao.js": "bricks/presentational-bricks:7oRX",
	"./Script/Latin.js": "bricks/presentational-bricks:dN2w",
	"./Script/Lepcha.js": "bricks/presentational-bricks:5bsx",
	"./Script/Limbu.js": "bricks/presentational-bricks:u9lQ",
	"./Script/Linear_A.js": "bricks/presentational-bricks:5scg",
	"./Script/Linear_B.js": "bricks/presentational-bricks:WPcv",
	"./Script/Lisu.js": "bricks/presentational-bricks:aE84",
	"./Script/Lycian.js": "bricks/presentational-bricks:/qLS",
	"./Script/Lydian.js": "bricks/presentational-bricks:lyes",
	"./Script/Mahajani.js": "bricks/presentational-bricks:uwDI",
	"./Script/Makasar.js": "bricks/presentational-bricks:jdFt",
	"./Script/Malayalam.js": "bricks/presentational-bricks:HYoX",
	"./Script/Mandaic.js": "bricks/presentational-bricks:bcGR",
	"./Script/Manichaean.js": "bricks/presentational-bricks:/pZ2",
	"./Script/Marchen.js": "bricks/presentational-bricks:LqhL",
	"./Script/Masaram_Gondi.js": "bricks/presentational-bricks:p1v9",
	"./Script/Medefaidrin.js": "bricks/presentational-bricks:z0Ef",
	"./Script/Meetei_Mayek.js": "bricks/presentational-bricks:IrW+",
	"./Script/Mende_Kikakui.js": "bricks/presentational-bricks:xEZB",
	"./Script/Meroitic_Cursive.js": "bricks/presentational-bricks:Hu3I",
	"./Script/Meroitic_Hieroglyphs.js": "bricks/presentational-bricks:wgmE",
	"./Script/Miao.js": "bricks/presentational-bricks:kd9n",
	"./Script/Modi.js": "bricks/presentational-bricks:cU+8",
	"./Script/Mongolian.js": "bricks/presentational-bricks:tUQf",
	"./Script/Mro.js": "bricks/presentational-bricks:5eRf",
	"./Script/Multani.js": "bricks/presentational-bricks:MG+M",
	"./Script/Myanmar.js": "bricks/presentational-bricks:kiIX",
	"./Script/Nabataean.js": "bricks/presentational-bricks:Uyem",
	"./Script/Nandinagari.js": "bricks/presentational-bricks:9Z7h",
	"./Script/New_Tai_Lue.js": "bricks/presentational-bricks:owni",
	"./Script/Newa.js": "bricks/presentational-bricks:v4Ei",
	"./Script/Nko.js": "bricks/presentational-bricks:whKM",
	"./Script/Nushu.js": "bricks/presentational-bricks:S/lv",
	"./Script/Nyiakeng_Puachue_Hmong.js": "bricks/presentational-bricks:Dpr8",
	"./Script/Ogham.js": "bricks/presentational-bricks:fdhu",
	"./Script/Ol_Chiki.js": "bricks/presentational-bricks:F8j9",
	"./Script/Old_Hungarian.js": "bricks/presentational-bricks:CD0r",
	"./Script/Old_Italic.js": "bricks/presentational-bricks:xaC0",
	"./Script/Old_North_Arabian.js": "bricks/presentational-bricks:twGC",
	"./Script/Old_Permic.js": "bricks/presentational-bricks:2+yD",
	"./Script/Old_Persian.js": "bricks/presentational-bricks:M9F6",
	"./Script/Old_Sogdian.js": "bricks/presentational-bricks:jWEa",
	"./Script/Old_South_Arabian.js": "bricks/presentational-bricks:F0lk",
	"./Script/Old_Turkic.js": "bricks/presentational-bricks:xqwB",
	"./Script/Oriya.js": "bricks/presentational-bricks:uEWo",
	"./Script/Osage.js": "bricks/presentational-bricks:1n5g",
	"./Script/Osmanya.js": "bricks/presentational-bricks:SZfN",
	"./Script/Pahawh_Hmong.js": "bricks/presentational-bricks:RMPE",
	"./Script/Palmyrene.js": "bricks/presentational-bricks:UVpH",
	"./Script/Pau_Cin_Hau.js": "bricks/presentational-bricks:MNEN",
	"./Script/Phags_Pa.js": "bricks/presentational-bricks:NhNr",
	"./Script/Phoenician.js": "bricks/presentational-bricks:34Qh",
	"./Script/Psalter_Pahlavi.js": "bricks/presentational-bricks:SzA2",
	"./Script/Rejang.js": "bricks/presentational-bricks:dC9X",
	"./Script/Runic.js": "bricks/presentational-bricks:t4pw",
	"./Script/Samaritan.js": "bricks/presentational-bricks:pPeY",
	"./Script/Saurashtra.js": "bricks/presentational-bricks:m7G6",
	"./Script/Sharada.js": "bricks/presentational-bricks:NcVZ",
	"./Script/Shavian.js": "bricks/presentational-bricks:RI8b",
	"./Script/Siddham.js": "bricks/presentational-bricks:ASKt",
	"./Script/SignWriting.js": "bricks/presentational-bricks:2JK7",
	"./Script/Sinhala.js": "bricks/presentational-bricks:LZTu",
	"./Script/Sogdian.js": "bricks/presentational-bricks:NpMe",
	"./Script/Sora_Sompeng.js": "bricks/presentational-bricks:Ng/I",
	"./Script/Soyombo.js": "bricks/presentational-bricks:6JnI",
	"./Script/Sundanese.js": "bricks/presentational-bricks:pyWQ",
	"./Script/Syloti_Nagri.js": "bricks/presentational-bricks:LBZI",
	"./Script/Syriac.js": "bricks/presentational-bricks:hy24",
	"./Script/Tagalog.js": "bricks/presentational-bricks:9H8i",
	"./Script/Tagbanwa.js": "bricks/presentational-bricks:sI65",
	"./Script/Tai_Le.js": "bricks/presentational-bricks:nFf/",
	"./Script/Tai_Tham.js": "bricks/presentational-bricks:isMi",
	"./Script/Tai_Viet.js": "bricks/presentational-bricks:IpiY",
	"./Script/Takri.js": "bricks/presentational-bricks:Rqf3",
	"./Script/Tamil.js": "bricks/presentational-bricks:mdlW",
	"./Script/Tangut.js": "bricks/presentational-bricks:n4XR",
	"./Script/Telugu.js": "bricks/presentational-bricks:xlHm",
	"./Script/Thaana.js": "bricks/presentational-bricks:DGa8",
	"./Script/Thai.js": "bricks/presentational-bricks:OQG6",
	"./Script/Tibetan.js": "bricks/presentational-bricks:MYbx",
	"./Script/Tifinagh.js": "bricks/presentational-bricks:ZAyF",
	"./Script/Tirhuta.js": "bricks/presentational-bricks:ojjd",
	"./Script/Ugaritic.js": "bricks/presentational-bricks:kcLn",
	"./Script/Vai.js": "bricks/presentational-bricks:5EYo",
	"./Script/Wancho.js": "bricks/presentational-bricks:IAU5",
	"./Script/Warang_Citi.js": "bricks/presentational-bricks:JUhp",
	"./Script/Yezidi.js": "bricks/presentational-bricks:16uS",
	"./Script/Yi.js": "bricks/presentational-bricks:t4zZ",
	"./Script/Zanabazar_Square.js": "bricks/presentational-bricks:0Z/U",
	"./Script_Extensions/Adlam.js": "bricks/presentational-bricks:mdLn",
	"./Script_Extensions/Ahom.js": "bricks/presentational-bricks:n75q",
	"./Script_Extensions/Anatolian_Hieroglyphs.js": "bricks/presentational-bricks:MHIA",
	"./Script_Extensions/Arabic.js": "bricks/presentational-bricks:1ygP",
	"./Script_Extensions/Armenian.js": "bricks/presentational-bricks:v1yY",
	"./Script_Extensions/Avestan.js": "bricks/presentational-bricks:YulU",
	"./Script_Extensions/Balinese.js": "bricks/presentational-bricks:S+sJ",
	"./Script_Extensions/Bamum.js": "bricks/presentational-bricks:6Ik7",
	"./Script_Extensions/Bassa_Vah.js": "bricks/presentational-bricks:KRcP",
	"./Script_Extensions/Batak.js": "bricks/presentational-bricks:zSGR",
	"./Script_Extensions/Bengali.js": "bricks/presentational-bricks:AyyQ",
	"./Script_Extensions/Bhaiksuki.js": "bricks/presentational-bricks:1ont",
	"./Script_Extensions/Bopomofo.js": "bricks/presentational-bricks:JQ99",
	"./Script_Extensions/Brahmi.js": "bricks/presentational-bricks:jaDh",
	"./Script_Extensions/Braille.js": "bricks/presentational-bricks:lnBL",
	"./Script_Extensions/Buginese.js": "bricks/presentational-bricks:rGMh",
	"./Script_Extensions/Buhid.js": "bricks/presentational-bricks:wcex",
	"./Script_Extensions/Canadian_Aboriginal.js": "bricks/presentational-bricks:uSeW",
	"./Script_Extensions/Carian.js": "bricks/presentational-bricks:zMEA",
	"./Script_Extensions/Caucasian_Albanian.js": "bricks/presentational-bricks:FJfz",
	"./Script_Extensions/Chakma.js": "bricks/presentational-bricks:9LXj",
	"./Script_Extensions/Cham.js": "bricks/presentational-bricks:sceD",
	"./Script_Extensions/Cherokee.js": "bricks/presentational-bricks:5TAg",
	"./Script_Extensions/Chorasmian.js": "bricks/presentational-bricks:jzOb",
	"./Script_Extensions/Common.js": "bricks/presentational-bricks:2rse",
	"./Script_Extensions/Coptic.js": "bricks/presentational-bricks:o3Hh",
	"./Script_Extensions/Cuneiform.js": "bricks/presentational-bricks:Piar",
	"./Script_Extensions/Cypriot.js": "bricks/presentational-bricks:Md75",
	"./Script_Extensions/Cyrillic.js": "bricks/presentational-bricks:CfQf",
	"./Script_Extensions/Deseret.js": "bricks/presentational-bricks:BSjU",
	"./Script_Extensions/Devanagari.js": "bricks/presentational-bricks:uEkq",
	"./Script_Extensions/Dives_Akuru.js": "bricks/presentational-bricks:qtun",
	"./Script_Extensions/Dogra.js": "bricks/presentational-bricks:6hTu",
	"./Script_Extensions/Duployan.js": "bricks/presentational-bricks:rTvz",
	"./Script_Extensions/Egyptian_Hieroglyphs.js": "bricks/presentational-bricks:zIrX",
	"./Script_Extensions/Elbasan.js": "bricks/presentational-bricks:iJwc",
	"./Script_Extensions/Elymaic.js": "bricks/presentational-bricks:SAe1",
	"./Script_Extensions/Ethiopic.js": "bricks/presentational-bricks:oT1F",
	"./Script_Extensions/Georgian.js": "bricks/presentational-bricks:p6v3",
	"./Script_Extensions/Glagolitic.js": "bricks/presentational-bricks:eSoS",
	"./Script_Extensions/Gothic.js": "bricks/presentational-bricks:0h7X",
	"./Script_Extensions/Grantha.js": "bricks/presentational-bricks:a8VH",
	"./Script_Extensions/Greek.js": "bricks/presentational-bricks:T9DP",
	"./Script_Extensions/Gujarati.js": "bricks/presentational-bricks:olBg",
	"./Script_Extensions/Gunjala_Gondi.js": "bricks/presentational-bricks:/Hxr",
	"./Script_Extensions/Gurmukhi.js": "bricks/presentational-bricks:9jCe",
	"./Script_Extensions/Han.js": "bricks/presentational-bricks:VqP8",
	"./Script_Extensions/Hangul.js": "bricks/presentational-bricks:RHGG",
	"./Script_Extensions/Hanifi_Rohingya.js": "bricks/presentational-bricks:dbxg",
	"./Script_Extensions/Hanunoo.js": "bricks/presentational-bricks:8Gun",
	"./Script_Extensions/Hatran.js": "bricks/presentational-bricks:6Ls2",
	"./Script_Extensions/Hebrew.js": "bricks/presentational-bricks:6gQq",
	"./Script_Extensions/Hiragana.js": "bricks/presentational-bricks:i6W2",
	"./Script_Extensions/Imperial_Aramaic.js": "bricks/presentational-bricks:8goA",
	"./Script_Extensions/Inherited.js": "bricks/presentational-bricks:TgRP",
	"./Script_Extensions/Inscriptional_Pahlavi.js": "bricks/presentational-bricks:m1ma",
	"./Script_Extensions/Inscriptional_Parthian.js": "bricks/presentational-bricks:lERh",
	"./Script_Extensions/Javanese.js": "bricks/presentational-bricks:xn3E",
	"./Script_Extensions/Kaithi.js": "bricks/presentational-bricks:K1Le",
	"./Script_Extensions/Kannada.js": "bricks/presentational-bricks:sR9r",
	"./Script_Extensions/Katakana.js": "bricks/presentational-bricks:MpeM",
	"./Script_Extensions/Kayah_Li.js": "bricks/presentational-bricks:EkIy",
	"./Script_Extensions/Kharoshthi.js": "bricks/presentational-bricks:73FR",
	"./Script_Extensions/Khitan_Small_Script.js": "bricks/presentational-bricks:suAS",
	"./Script_Extensions/Khmer.js": "bricks/presentational-bricks:jRTF",
	"./Script_Extensions/Khojki.js": "bricks/presentational-bricks:6zB/",
	"./Script_Extensions/Khudawadi.js": "bricks/presentational-bricks:GI2u",
	"./Script_Extensions/Lao.js": "bricks/presentational-bricks:PQ0K",
	"./Script_Extensions/Latin.js": "bricks/presentational-bricks:2BBF",
	"./Script_Extensions/Lepcha.js": "bricks/presentational-bricks:tF1p",
	"./Script_Extensions/Limbu.js": "bricks/presentational-bricks:zyj0",
	"./Script_Extensions/Linear_A.js": "bricks/presentational-bricks:lFV7",
	"./Script_Extensions/Linear_B.js": "bricks/presentational-bricks:jawv",
	"./Script_Extensions/Lisu.js": "bricks/presentational-bricks:qzaw",
	"./Script_Extensions/Lycian.js": "bricks/presentational-bricks:wqYY",
	"./Script_Extensions/Lydian.js": "bricks/presentational-bricks:n+Zh",
	"./Script_Extensions/Mahajani.js": "bricks/presentational-bricks:z8DC",
	"./Script_Extensions/Makasar.js": "bricks/presentational-bricks:RNCu",
	"./Script_Extensions/Malayalam.js": "bricks/presentational-bricks:wtBk",
	"./Script_Extensions/Mandaic.js": "bricks/presentational-bricks:untw",
	"./Script_Extensions/Manichaean.js": "bricks/presentational-bricks:n1Oh",
	"./Script_Extensions/Marchen.js": "bricks/presentational-bricks:8fW5",
	"./Script_Extensions/Masaram_Gondi.js": "bricks/presentational-bricks:JBN+",
	"./Script_Extensions/Medefaidrin.js": "bricks/presentational-bricks:02tC",
	"./Script_Extensions/Meetei_Mayek.js": "bricks/presentational-bricks:PoXS",
	"./Script_Extensions/Mende_Kikakui.js": "bricks/presentational-bricks:7jK8",
	"./Script_Extensions/Meroitic_Cursive.js": "bricks/presentational-bricks:U8oa",
	"./Script_Extensions/Meroitic_Hieroglyphs.js": "bricks/presentational-bricks:WAkd",
	"./Script_Extensions/Miao.js": "bricks/presentational-bricks:G1tY",
	"./Script_Extensions/Modi.js": "bricks/presentational-bricks:HwGp",
	"./Script_Extensions/Mongolian.js": "bricks/presentational-bricks:WGqn",
	"./Script_Extensions/Mro.js": "bricks/presentational-bricks:UQmg",
	"./Script_Extensions/Multani.js": "bricks/presentational-bricks:WfgX",
	"./Script_Extensions/Myanmar.js": "bricks/presentational-bricks:bqHw",
	"./Script_Extensions/Nabataean.js": "bricks/presentational-bricks:pjPY",
	"./Script_Extensions/Nandinagari.js": "bricks/presentational-bricks:ObV2",
	"./Script_Extensions/New_Tai_Lue.js": "bricks/presentational-bricks:ZsYH",
	"./Script_Extensions/Newa.js": "bricks/presentational-bricks:5tk3",
	"./Script_Extensions/Nko.js": "bricks/presentational-bricks:/kDM",
	"./Script_Extensions/Nushu.js": "bricks/presentational-bricks:JSPL",
	"./Script_Extensions/Nyiakeng_Puachue_Hmong.js": "bricks/presentational-bricks:xsuf",
	"./Script_Extensions/Ogham.js": "bricks/presentational-bricks:2PVI",
	"./Script_Extensions/Ol_Chiki.js": "bricks/presentational-bricks:NTOk",
	"./Script_Extensions/Old_Hungarian.js": "bricks/presentational-bricks:IK5f",
	"./Script_Extensions/Old_Italic.js": "bricks/presentational-bricks:VHj/",
	"./Script_Extensions/Old_North_Arabian.js": "bricks/presentational-bricks:XcdB",
	"./Script_Extensions/Old_Permic.js": "bricks/presentational-bricks:kp9+",
	"./Script_Extensions/Old_Persian.js": "bricks/presentational-bricks:kAvF",
	"./Script_Extensions/Old_Sogdian.js": "bricks/presentational-bricks:oml3",
	"./Script_Extensions/Old_South_Arabian.js": "bricks/presentational-bricks:F3Lr",
	"./Script_Extensions/Old_Turkic.js": "bricks/presentational-bricks:ZaWa",
	"./Script_Extensions/Oriya.js": "bricks/presentational-bricks:MA0n",
	"./Script_Extensions/Osage.js": "bricks/presentational-bricks:i1w3",
	"./Script_Extensions/Osmanya.js": "bricks/presentational-bricks:EVgB",
	"./Script_Extensions/Pahawh_Hmong.js": "bricks/presentational-bricks:EJMw",
	"./Script_Extensions/Palmyrene.js": "bricks/presentational-bricks:kCFO",
	"./Script_Extensions/Pau_Cin_Hau.js": "bricks/presentational-bricks:96ys",
	"./Script_Extensions/Phags_Pa.js": "bricks/presentational-bricks:jca9",
	"./Script_Extensions/Phoenician.js": "bricks/presentational-bricks:sMr2",
	"./Script_Extensions/Psalter_Pahlavi.js": "bricks/presentational-bricks:yP4Y",
	"./Script_Extensions/Rejang.js": "bricks/presentational-bricks:AkQd",
	"./Script_Extensions/Runic.js": "bricks/presentational-bricks:Dm2Y",
	"./Script_Extensions/Samaritan.js": "bricks/presentational-bricks:zWlK",
	"./Script_Extensions/Saurashtra.js": "bricks/presentational-bricks:wOBA",
	"./Script_Extensions/Sharada.js": "bricks/presentational-bricks:idKo",
	"./Script_Extensions/Shavian.js": "bricks/presentational-bricks:Wp8k",
	"./Script_Extensions/Siddham.js": "bricks/presentational-bricks:0OBK",
	"./Script_Extensions/SignWriting.js": "bricks/presentational-bricks:mJRM",
	"./Script_Extensions/Sinhala.js": "bricks/presentational-bricks:7xP4",
	"./Script_Extensions/Sogdian.js": "bricks/presentational-bricks:9VM+",
	"./Script_Extensions/Sora_Sompeng.js": "bricks/presentational-bricks:jM+1",
	"./Script_Extensions/Soyombo.js": "bricks/presentational-bricks:ZSfS",
	"./Script_Extensions/Sundanese.js": "bricks/presentational-bricks:xs8s",
	"./Script_Extensions/Syloti_Nagri.js": "bricks/presentational-bricks:X29h",
	"./Script_Extensions/Syriac.js": "bricks/presentational-bricks:HUGt",
	"./Script_Extensions/Tagalog.js": "bricks/presentational-bricks:9/o/",
	"./Script_Extensions/Tagbanwa.js": "bricks/presentational-bricks:Cw5x",
	"./Script_Extensions/Tai_Le.js": "bricks/presentational-bricks:64uU",
	"./Script_Extensions/Tai_Tham.js": "bricks/presentational-bricks:7GeA",
	"./Script_Extensions/Tai_Viet.js": "bricks/presentational-bricks:wA4O",
	"./Script_Extensions/Takri.js": "bricks/presentational-bricks:MSEK",
	"./Script_Extensions/Tamil.js": "bricks/presentational-bricks:+XeO",
	"./Script_Extensions/Tangut.js": "bricks/presentational-bricks:X2h1",
	"./Script_Extensions/Telugu.js": "bricks/presentational-bricks:a37I",
	"./Script_Extensions/Thaana.js": "bricks/presentational-bricks:YXr4",
	"./Script_Extensions/Thai.js": "bricks/presentational-bricks:9mTJ",
	"./Script_Extensions/Tibetan.js": "bricks/presentational-bricks:hQqI",
	"./Script_Extensions/Tifinagh.js": "bricks/presentational-bricks:MBkK",
	"./Script_Extensions/Tirhuta.js": "bricks/presentational-bricks:wmPc",
	"./Script_Extensions/Ugaritic.js": "bricks/presentational-bricks:tgrt",
	"./Script_Extensions/Vai.js": "bricks/presentational-bricks:cyPN",
	"./Script_Extensions/Wancho.js": "bricks/presentational-bricks:ELeP",
	"./Script_Extensions/Warang_Citi.js": "bricks/presentational-bricks:JEgC",
	"./Script_Extensions/Yezidi.js": "bricks/presentational-bricks:8nCx",
	"./Script_Extensions/Yi.js": "bricks/presentational-bricks:CnAY",
	"./Script_Extensions/Zanabazar_Square.js": "bricks/presentational-bricks:Xx7p",
	"./index.js": "bricks/presentational-bricks:aAIp",
	"./unicode-version.js": "bricks/presentational-bricks:9NKt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bricks/presentational-bricks:PML8";